import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=7ec72283&"
import script from "./Trading.vue?vue&type=script&lang=ts&"
export * from "./Trading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports